export default __webpack_public_path__ + "static/media/Tup.e0029265.jpg";